export default __webpack_public_path__ + "static/media/filter-img.18ba99bb.svg";